import React from 'react'

import { GetStaticProps, InferGetStaticPropsType } from 'next'
import { useSession } from 'next-auth/react'

import { RiLoaderFill } from 'react-icons/ri'

import Layout from '@/components/Layout'
import { AuthGuard } from '@/features/auth/components'
import { AccountHomeView } from '@/features/customer-portal/views'
import { NextSeo } from 'next-seo'

const AccountPage: React.FC = (
  props: InferGetStaticPropsType<typeof getStaticProps>
) => {
  const { data: session, status } = useSession()

  return (
    <>
      <Layout mutedBackground showLiveChatWidget>
        <div className={'page-wrapper max-w-5xl mx-auto'}>
          <AuthGuard>
            {status === 'loading' && (
              <RiLoaderFill className={'loader text-4xl mx-auto'} />
            )}
            {status === 'authenticated' && session && (
              <>
                <h2 className={'text-center font-bold text-2xl sm:text-3xl'}>
                  Welcome {session.user?.name}
                </h2>

                <AccountHomeView />
              </>
            )}
          </AuthGuard>
        </div>
      </Layout>
      <NextSeo title={'MY ACCOUNT'} />
    </>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  return {
    props: {},
  }
}

export default AccountPage
